export default "__VITE_ASSET__0AtXndFm__"